import React, { useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import { useIdHash } from '../../hooks/custom.hooks';
import CustomImg from '../../components/CustomImg';
import { usePreloadImages } from '../../hooks/usePreloadImages';
import { useAppOffers } from '../../api/api.calls';
import { callFlutterHandler } from '../../utils/flutterBridge';
import { ctLogV2 } from '../../utils/cleverTapLogger.utils';

function DynamicOffers() {
  const { data: apiResponse, isLoading } = useAppOffers();
  const app_offers = useMemo(() => {
    return apiResponse?.data?.app_offers;
  }, [apiResponse]);
  const { offerIds, brandIds } = useMemo(() => {
    return {
      offerIds: app_offers?.map((offer) => offer.voucher_id),
      brandIds: app_offers?.map((offer) => offer.brand_id),
    };
  }, [app_offers]);
  const isLoadingImages = usePreloadImages(app_offers);
  const { custId: cid, hash } = useIdHash();
  const origin = window.location.origin;
  const url = `${origin}/offers?cid=${cid}&customer-hash=${hash}&app=1`;
  const detailsPageUrl = `${origin}/dynamic-offers-detailPage?cid=${cid}&customer-hash=${hash}&app=1`;

  useEffect(() => {
    if (!isLoading && app_offers?.length > 0) {
      ctLogV2({
        eventName: 'appOffersHomepageViewed',
        customerId: cid,
        extraData: {
          offerId: JSON.stringify(offerIds) || null,
          brandId: JSON.stringify(brandIds) || null,
        },
      });
    }
  }, [isLoading, cid, offerIds, brandIds, app_offers]);

  const handleOfferClick = (card, event) => {
    if (!event.isTrusted) return;
    ctLogV2({
      eventName: 'appOffersHomepageClicked',
      customerId: cid,
      extraData: {
        offerId: card?.offer_id || null,
        brandId: card?.brand_id || null,
      },
    });
    localStorage.setItem('selectedDynamicOffers', JSON.stringify(card));
    callFlutterHandler('openWebView', {
      url: card?.static_web_url ? card?.static_web_url : detailsPageUrl,
    });
  };

  const ShimmerCard = () => {
    return (
      <div className={styles.shimmerRow}>
        {[1, 2].map((_, index) => (
          <div key={index} className={styles.shimmerCard}>
            <div className={styles.shimmerImage}></div>
          </div>
        ))}
      </div>
    );
  };

  const ImageCard = ({ card }) => {
    return (
      <div className={styles.cutoutCard}>
        <div
          className={styles.cutoutCardSection}
          onClick={(e) => handleOfferClick(card, e)}
        >
          <div className={styles.topSection}>
            <CustomImg
              src={`${card?.offer_image}?v=1.0.1`}
              fallbackSrc={`${card?.offer_image}?v=1.0.2`}
              alt={card?.brand_name}
              className={styles.brandBanner}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.offerSectionRow}>
        <div className={styles.headerRow}>
          <div className={styles.sectionName}>Featured for you</div>
          <div
            className={styles.viewAllBtn}
            onClick={() =>
              // window?.flutter_inappwebview?.callHandler(
              //   'Flutter',
              //   JSON.stringify({
              //     action: 'openWebView',
              //     url: url,
              //   }),
              // )
              callFlutterHandler('openWebView', { url: url })
            }
          >
            View All
          </div>
        </div>
        <div className={styles.dataScrollRow}>
          {isLoading || isLoadingImages ? (
            <ShimmerCard />
          ) : (
            app_offers?.map((entry, key) => (
              <ImageCard card={entry} key={key} />
            ))
          )}
        </div>
      </div>
    </>
  );
}

export default DynamicOffers;
